import React from "react";
import { Box, Typography, FormControlLabel, Checkbox, Chip } from "@material-ui/core";

// Selector de qué atributos del participante aparecen en la etiqueta.
// Nombres, apellidos y número no se muestran aquí: ya están siempre
// incluidos en un lugar fijo del diseño de la etiqueta.
export default function AttributePickerEditor({ atributosDisponibles, selectedAttributes, onChange }) {
  const seleccionados = new Set(selectedAttributes || []);

  function toggle(key) {
    const nuevo = new Set(seleccionados);
    if (nuevo.has(key)) nuevo.delete(key);
    else nuevo.add(key);
    onChange(Array.from(nuevo));
  }

  const fijos = atributosDisponibles.filter((a) => a.source === "core");
  const personalizados = atributosDisponibles.filter((a) => a.source === "custom");

  return (
    <Box>
      <Box mb={1}>
        <Chip size="small" label="Siempre incluidos: Nombres, Apellidos, Número" />
      </Box>

      <Typography variant="subtitle2" gutterBottom>
        Campos fijos del evento
      </Typography>
      <Box mb={2} display="flex" flexWrap="wrap" style={{ gap: 4 }}>
        {fijos.map((a) => (
          <FormControlLabel
            key={a.key}
            control={<Checkbox checked={seleccionados.has(a.key)} onChange={() => toggle(a.key)} />}
            label={a.label}
          />
        ))}
      </Box>

      {personalizados.length > 0 && (
        <>
          <Typography variant="subtitle2" gutterBottom>
            Campos personalizados
          </Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
            {personalizados.map((a) => (
              <FormControlLabel
                key={a.key}
                control={<Checkbox checked={seleccionados.has(a.key)} onChange={() => toggle(a.key)} />}
                label={a.label}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
}
